import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from '../_authenticated'
import { SubscriptionSettings } from '@/pages/settings'

export const subscriptionSettingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings/subscription',
  component: SubscriptionSettings,
})
